import { SignatureDTO } from '../../../api/plyca-dtos';

export function flattenSignatures(signatureTree: SignatureDTO[]): SignatureDTO[] {
  const flattenedList: SignatureDTO[] = [];

  function signatureListRecursive(treeList: SignatureDTO[]): void {
    if (treeList && treeList.length > 0) {
      treeList.forEach(item => {
        flattenedList.push(item);
        signatureListRecursive(item.signatures);
      });
    }
  }

  signatureListRecursive(signatureTree);

  return flattenedList.sort((a, b) =>
    a.date < b.date ? -1 : a.date > b.date ? 1 : 0
  );
}
